import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'

import { useAuthStore } from 'Store/Auth'

const initialValues = {
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
}

const changePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required('กรุณากรอกรหัสผ่านปัจจุบัน'),
  newPassword: Yup.string()
    .min(3, 'ต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(50, 'สูงสุด 50 ตัวอักษร')
    .notOneOf([Yup.ref('oldPassword')], 'รหัสผ่านใหม่ต้องไม่ซ้ำกับรหัสผ่านปัจจุบัน')
    .required('กรุณากรอกรหัสผ่านใหม่'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'รหัสผ่านไม่ตรงกัน')
    .required('กรุณายืนยันรหัสผ่านใหม่'),
})

const useViewModel = () => {
  const changePassword = useAuthStore(state => state.changePassword)

  const formik = useFormik({
    initialValues,
    validationSchema: changePasswordSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true)
      const { success, data } = await changePassword(values.oldPassword, values.newPassword)
      setSubmitting(false)

      if (success) {
        toast.success('เปลี่ยนรหัสผ่านสำเร็จ')
        resetForm()
      } else {
        toast.error(typeof data === 'string' ? data : 'เปลี่ยนรหัสผ่านไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
      }
    },
  })

  return { formik }
}

export default useViewModel
